import { useQuery } from "@apollo/react-hooks";
import { MY_HR_GET_POSTAL_CODES } from "my-hr/graphql";

export const useMyHrPostalCodes = () => {
  const { data, loading, error } = useQuery(MY_HR_GET_POSTAL_CODES, {
    fetchPolicy: "cache-and-network",
  });

  return {
    data: data?.postalCodes || [],
    loading,
    error,
  };
};

export default useMyHrPostalCodes;
